// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { UserServiceRequest } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

const useUserServiceRequests: () => UseQueryResult<
  TemplateContract<UserServiceRequest>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data;
  const offset = useLedgerEnd();

  return useQuery({
    enabled: !!(operator && offset),
    queryKey: ['queryCollateralUserServiceRequests', ledgerApi, operator, offset],
    queryFn: async () => {
      if (!offset || !operator) {
        return Promise.resolve([]);
      }
      return ledgerApi.queryCollateralUserServiceRequests(offset, operator);
    },
    refetchInterval: false,
  });
};

export default useUserServiceRequests;
